export enum OrderItemPrint {
    ORDER_NUMBER = 'Numero ordinamento',
    ALPHABETICAL = 'Alfabetico'
}
